import actions from './actions';
import initialState from '../initialState';

export const lendingLimitReducer = (state = initialState.lendingLimit, action) => {
    switch (action.type) {
        case actions.LENDING_LIMIT_LOAN_SUMMARY_MODAL:
            return {
                ...state,
                lendingLimitLoanSummaryModal: action.state.lendingLimitLoanSummaryModal,
            };
        default:
            return { ...state };
    }
};

export default lendingLimitReducer;
